// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { userHeadset16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-user-headset': IconUserHeadset;
    }
}

/**
 * The icon component for the 'userHeadset' icon
 */
export class IconUserHeadset extends IconSvg {
    public constructor() {
        super(userHeadset16X16);
    }
}

registerIconSvg('icon-user-headset', IconUserHeadset);
export const iconUserHeadsetTag = 'nimble-icon-user-headset';
